import {DateTime} from 'luxon';
import {Collection} from '@src/types/configurations';

export type CollectionDateTimeRange = {
  from: DateTime | null;
  to: DateTime | null;
};

export type CollectionDateTimeRangeWithDefault = Required<{
  [K in keyof CollectionDateTimeRange]: NonNullable<CollectionDateTimeRange[K]>;
}>;

export const parseDateTimeFromCollection = (
  collection?: Collection,
): CollectionDateTimeRange => {
  const [from, to] = collection?.extent?.temporal?.interval?.[0] || [];

  return {
    from: from ? DateTime.fromISO(from) : null,
    to: to ? DateTime.fromISO(to) : null,
  };
};

export const parseDateTimeFromCollectionWithDefaults = (
  collection?: Collection,
): CollectionDateTimeRangeWithDefault => {
  const {from, to} = parseDateTimeFromCollection(collection);

  const effectiveTo = to ?? DateTime.now();
  const effectiveFrom = from ?? effectiveTo.minus({months: 1});

  return {
    from: effectiveFrom.startOf('day'),
    to: effectiveTo.endOf('day'),
  };
};
